// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"252":"f22c1483","259":"24732e65","277":"5a2edc69","283":"5124b04b","343":"219ae3bf","382":"79ca7c39","410":"bf649cdc","431":"49265771","477":"091a505e","524":"edf90ee6","542":"6d02f8e2","740":"c15b0e9c","949":"e625f05e","999":"2152f647"}[chunkId] + ".js";
};